const round5 = (value) => {
  return Math.ceil(value / 5) * 5;
};

export default round5;
